import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let userInfo = JSON.parse(localStorage.getItem('userInfo'))?JSON.parse(localStorage.getItem('userInfo')) :{};
let appInfo = JSON.parse(localStorage.getItem('appInfo'))?JSON.parse(localStorage.getItem('appInfo')) :{};
let messageNum = localStorage.getItem("messageNum") || 0 ;
let token = sessionStorage.getItem("token") || '';

export default new Vuex.Store({
  //state存放状态,
  state: {
    userInfo,
    token,

    messageNum,
    appInfo
  },
  //getter为state的计算属性
  getters: {
    
  },
  //mutations可更改状态的逻辑，同步操作
  mutations: {
    changToken(state){

      state.token = sessionStorage.getItem('token') || ''; 
    },
    changUserInfo(state){
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        state.userInfo = userInfo ;
    },
    changappInfo(state){
      let appInfo = JSON.parse(localStorage.getItem('appInfo'))
      state.appInfo = appInfo ;
  }
    ,changMessageNum(state){
      let show = localStorage.getItem('show');
      state.messageNum = show ? 0 : localStorage.getItem('messageNum'); 
    }
  },
  //提交mutation，异步操作
  actions: {
    
  },
  // 将store模块化
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js